/* Turf Care Pro — collection page v2 (5-10-2026). Vanilla JS. All products are in the HTML; this filters/sorts them. */
(function () {
  'use strict';
  var GBP = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' });
  var NUM = function (n, d) { return new Intl.NumberFormat('en-GB', { maximumFractionDigits: d || 0 }).format(n); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }
  var ICON = {
    selective: '<path d="M12 21V9"/><path d="M12 13c-3 0-5-2-5-5 3 0 5 2 5 5zM12 11c0-3 2-5 5-5 0 3-2 5-5 5z"/><path d="M4 21h16"/>',
    total: '<circle cx="12" cy="12" r="8"/><path d="m6.5 6.5 11 11"/>',
    'long-lasting': '<circle cx="12" cy="13" r="8"/><path d="M12 9v4l3 2M9 2h6"/>',
    'moss-algae': '<path d="M12 3c3 4 5 7 5 10a5 5 0 0 1-10 0c0-3 2-6 5-10z"/>',
    specialist: '<path d="M12 2v20M5 9c3 0 7 2 7 6M19 7c-3 0-7 2-7 6"/>',
    fungicide: '<path d="M4 12a8 8 0 0 1 16 0z"/><path d="M10 12v7a2 2 0 0 0 4 0v-7"/>',
    insecticide: '<ellipse cx="12" cy="14" rx="4" ry="6"/><path d="M12 8V5M8 4l2 3M16 4l-2 3M8 13H4M20 13h-4M8 17l-3 2M16 17l3 2"/>',
    biological: '<circle cx="12" cy="12" r="3"/><path d="M12 2v4M12 18v4M2 12h4M18 12h4M5 5l3 3M16 16l3 3M19 5l-3 3M8 16l-3 3"/>',
    adjuvant: '<path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3"/>',
    equipment: '<path d="M4 20l6-6M9 9l6 6M14 4l6 6-5 5-6-6z"/>'
  };
  var BANDS = [['u50', 'Under £50', 0, 5000], ['50-150', '£50 to £150', 5000, 15000], ['o150', 'Over £150', 15000, 1e12]];

  function packOf(card) {
    var vt = card.getAttribute('data-vt'), out = [];
    var src = vt ? vt.split('|') : [card.getAttribute('data-t')];
    src.forEach(function (s) {
      var m = String(s).match(/(\d+(?:\.\d+)?)\s?(ml|l|litres?|ltr|g|kg)\b(?!\s*\/)/i);
      if (m) {
        var u = m[2].toLowerCase(); u = u === 'ml' ? 'ml' : (u === 'g' ? 'g' : (u === 'kg' ? 'kg' : 'L'));
        var lab = (+m[1]) + (u === 'L' ? ' L' : ' ' + u);
        if (out.indexOf(lab) < 0) out.push(lab);
      }
    });
    return out;
  }
  function activesOf(card) {
    var a = card.getAttribute('data-act'); if (!a) return [];
    return a.split('+').map(function (x) {
      x = x.replace(/\(.*?\)/g, '').replace(/^\s*[\d.,]+\s*(%\s*w\/w|g\/l|g\/kg|g\/L|%)?\s*/i, '').trim();
      return x ? x.charAt(0).toUpperCase() + x.slice(1) : '';
    }).filter(Boolean);
  }

  function init(root) {
    if (root.__tcc) return; root.__tcc = true;
    var PER = +root.getAttribute('data-per') || 24;
    var grid = root.querySelector('[data-tcc-grid]');
    var cards = Array.prototype.slice.call(grid.children);
    var state = { type: '', price: [], pack: [], active: [], sort: 'default', limit: PER, ex: false, cmp: [], cmpHidden: false };

    cards.forEach(function (c) {
      c._p = +c.getAttribute('data-p'); c._pmax = +c.getAttribute('data-pmax');
      c._type = c.getAttribute('data-type') || ''; c._typeK = c._type.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
      c._pack = packOf(c); c._act = activesOf(c); c._i = +c.getAttribute('data-i');
      c._band = BANDS.filter(function (b) { return c._p >= b[2] && c._p < b[3]; }).map(function (b) { return b[0]; });
    });

    /* ---------- facets ---------- */
    function countBy(fn) { var m = {}; cards.forEach(function (c) { fn(c).forEach(function (k) { m[k] = (m[k] || 0) + 1; }); }); return m; }
    function buildGroup(name, entries, max) {
      var g = root.querySelector('[data-tcc-fg="' + name + '"]'), box = g.querySelector('[data-tcc-opts]');
      if (entries.length < 2) { g.hidden = true; return; }
      var html = entries.map(function (e, k) {
        return '<label class="tcc-opt"' + (max && k >= max ? ' data-more hidden' : '') + '><input type="checkbox" value="' + esc(e[0]) + '" data-f="' + name + '"><span>' + esc(e[1]) + '</span><small>' + e[2] + '</small></label>';
      }).join('');
      if (max && entries.length > max) html += '<button type="button" class="tcc-showall">Show all ' + entries.length + '</button>';
      box.innerHTML = html;
      var sa = box.querySelector('.tcc-showall');
      if (sa) sa.addEventListener('click', function () { box.querySelectorAll('[data-more]').forEach(function (l) { l.hidden = false; }); sa.remove(); });
    }
    var bc = countBy(function (c) { return c._band; });
    buildGroup('price', BANDS.filter(function (b) { return bc[b[0]]; }).map(function (b) { return [b[0], b[1], bc[b[0]]]; }));
    var pc = countBy(function (c) { return c._pack; });
    var packs = Object.keys(pc).sort(function (a, b) {
      function base(x) { var n = parseFloat(x), u = x.split(' ')[1]; return n * (u === 'kg' || u === 'L' ? 1000 : 1) + (u === 'g' || u === 'kg' ? 1e7 : 0); }
      return base(a) - base(b);
    });
    buildGroup('pack', packs.map(function (k) { return [k, k, pc[k]]; }));
    var ac = countBy(function (c) { return c._act; });
    buildGroup('active', Object.keys(ac).sort(function (a, b) { return ac[b] - ac[a] || a.localeCompare(b); }).map(function (k) { return [k, k, ac[k]]; }), 6);
    root.querySelectorAll('[data-f]').forEach(function (i) {
      i.addEventListener('change', function () {
        var arr = state[i.getAttribute('data-f')], k = arr.indexOf(i.value);
        if (i.checked && k < 0) arr.push(i.value); if (!i.checked && k > -1) arr.splice(k, 1);
        state.limit = PER; render();
      });
    });
    var filt = root.querySelector('[data-tcc-filt]');
    var anyFacet = Array.prototype.some.call(filt.querySelectorAll('[data-tcc-fg]'), function (g) { return !g.hidden; });
    if (!anyFacet) { filt.classList.add('is-empty'); root.querySelector('[data-tcc-filtopen]').hidden = true; }

    /* ---------- type tiles ---------- */
    var tc = countBy(function (c) { return c._type ? [c._type] : []; });
    var types = Object.keys(tc).sort(function (a, b) { return (a === 'Equipment') - (b === 'Equipment') || tc[b] - tc[a]; });
    if (types.length >= 2) {
      var tg = root.querySelector('[data-tcc-tilegrid]');
      tg.innerHTML = types.map(function (t) {
        var k = t.toLowerCase().replace(/&/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
        var name = { Selective: 'Turf, lawns & grassland', Total: 'Total weed killers', 'Long-lasting': 'Long-lasting control', 'Moss & algae': 'Moss & algae', Specialist: 'Specialist weeds', Equipment: 'Sprayers & accessories', Insecticide: 'Insect pests', Biological: 'Biological controls', Adjuvant: 'Spray additives', Fungicide: 'Turf diseases' }[t] || t;
        return '<button type="button" class="tcc-tile" data-tile="' + esc(t) + '" aria-pressed="false"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICON[k] || ICON.equipment) + '</svg><b>' + esc(name) + '</b><small>' + tc[t] + (tc[t] === 1 ? ' product' : ' products') + '</small></button>';
      }).join('');
      root.querySelector('[data-tcc-tiles]').hidden = false;
      tg.querySelectorAll('[data-tile]').forEach(function (b) {
        b.addEventListener('click', function () {
          var t = b.getAttribute('data-tile'); state.type = state.type === t ? '' : t; state.limit = PER; render();
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    /* ---------- type guide ---------- */
    var guide = root.querySelector('[data-tcc-guide]'), shownRows = 0;
    guide.querySelectorAll('tr[data-g]').forEach(function (r) {
      var on = cards.some(function (c) { return c._typeK === r.getAttribute('data-g'); }); r.hidden = !on; if (on) shownRows++;
    });
    var anyPro = cards.some(function (c) { return c.getAttribute('data-pro') === '1'; });
    if (anyPro) root.querySelector('[data-tcc-procard]').hidden = false;
    if (shownRows < 2) guide.querySelector('.tcc-guide__t').hidden = true;
    guide.hidden = !(shownRows >= 2 || anyPro);

    /* ---------- VAT ---------- */
    function paintPrices() {
      cards.forEach(function (c) {
        var tax = c.getAttribute('data-tax') === '1', el = c.querySelector('[data-tcc-price]'), l = c.querySelector('[data-tcc-vatl]');
        var v = state.ex && tax ? Math.round(c._p / 1.2) : c._p;
        el.textContent = (c._pmax > c._p ? 'From ' : '') + GBP.format(v / 100);
        if (l) l.textContent = tax ? (state.ex ? 'ex. VAT' : 'inc. VAT') : '';
      });
      root.querySelectorAll('[data-tcc-vat]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-tcc-vat') === 'ex') === state.ex)); });
    }
    root.querySelectorAll('[data-tcc-vat]').forEach(function (b) {
      b.addEventListener('click', function () { state.ex = b.getAttribute('data-tcc-vat') === 'ex'; try { localStorage.setItem('tcpVat', state.ex ? 'ex' : 'inc'); } catch (e) {} paintPrices(); renderCmp(); });
    });

    /* ---------- sort ---------- */
    var sortSel = root.querySelector('[data-tcc-sort]');
    sortSel.addEventListener('change', function () { state.sort = sortSel.value; render(); });

    /* ---------- render ---------- */
    function match(c) {
      if (state.type && c._type !== state.type) return false;
      if (state.price.length && !c._band.some(function (b) { return state.price.indexOf(b) > -1; })) return false;
      if (state.pack.length && !c._pack.some(function (b) { return state.pack.indexOf(b) > -1; })) return false;
      if (state.active.length && !c._act.some(function (b) { return state.active.indexOf(b) > -1; })) return false;
      return true;
    }
    var nEl = root.querySelector('[data-tcc-n]'), n2 = root.querySelector('[data-tcc-n2]');
    function render() {
      var list = cards.slice();
      if (state.sort === 'price-asc') list.sort(function (a, b) { return a._p - b._p || a._i - b._i; });
      else if (state.sort === 'price-desc') list.sort(function (a, b) { return b._p - a._p || a._i - b._i; });
      else if (state.sort === 'title') list.sort(function (a, b) { return a.getAttribute('data-t').localeCompare(b.getAttribute('data-t')); });
      else list.sort(function (a, b) { return a._i - b._i; });
      var hits = 0;
      list.forEach(function (c) {
        grid.appendChild(c);
        var ok = match(c);
        if (ok) hits++;
        c.hidden = !ok || hits > state.limit;
      });
      nEl.textContent = hits; if (n2) n2.textContent = hits;
      root.querySelector('[data-tcc-empty]').hidden = hits > 0;
      var shown = Math.min(hits, state.limit);
      root.querySelector('[data-tcc-shown]').textContent = shown;
      root.querySelector('[data-tcc-total]').textContent = hits;
      root.querySelector('[data-tcc-morebar]').style.width = (hits ? shown / hits * 100 : 0) + '%';
      var more = root.querySelector('[data-tcc-more]'), left = hits - shown;
      root.querySelector('[data-tcc-morewrap]').hidden = hits <= PER && shown === hits;
      more.hidden = left <= 0; more.textContent = 'Show ' + Math.min(PER, left) + ' more';
      root.querySelectorAll('[data-tile]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-tile') === state.type)); });
      /* active filter chips */
      var chips = [];
      if (state.type) chips.push(['type', state.type, state.type]);
      state.price.forEach(function (p) { chips.push(['price', p, BANDS.filter(function (b) { return b[0] === p; })[0][1]]); });
      state.pack.forEach(function (p) { chips.push(['pack', p, p]); });
      state.active.forEach(function (p) { chips.push(['active', p, p]); });
      var act = root.querySelector('[data-tcc-active]');
      act.hidden = !chips.length;
      act.innerHTML = chips.map(function (c) { return '<button type="button" data-rm="' + c[0] + '|' + esc(c[1]) + '">' + esc(c[2]) + ' <span aria-hidden="true">×</span><span class="tcc-vh">Remove filter</span></button>'; }).join('') + (chips.length ? '<button type="button" class="tcc-clr" data-tcc-clear>Clear all</button>' : '');
      act.querySelectorAll('[data-rm]').forEach(function (b) {
        b.addEventListener('click', function () {
          var p = b.getAttribute('data-rm').split('|'), k = p[0], val = p.slice(1).join('|');
          if (k === 'type') state.type = ''; else { var a = state[k]; a.splice(a.indexOf(val), 1); var i = filt.querySelector('[data-f="' + k + '"][value="' + CSS.escape(val) + '"]'); if (i) i.checked = false; }
          render();
        });
      });
      act.querySelectorAll('[data-tcc-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });
      var fc = state.price.length + state.pack.length + state.active.length;
      root.querySelector('[data-tcc-fcount]').textContent = fc ? '(' + fc + ')' : '';
    }
    function clearAll() {
      state.type = ''; state.price = []; state.pack = []; state.active = []; state.limit = PER;
      filt.querySelectorAll('[data-f]').forEach(function (i) { i.checked = false; });
      render();
    }
    root.querySelectorAll('[data-tcc-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });
    root.querySelector('[data-tcc-more]').addEventListener('click', function () {
      var first = state.limit; state.limit += PER; render();
      var next = cards.filter(function (c) { return !c.hidden; })[first]; if (next) { var a = next.querySelector('a'); if (a) a.focus({ preventScroll: true }); }
    });

    /* ---------- mobile filter drawer ---------- */
    var scrim = root.querySelector('[data-tcc-scrim]');
    function drawer(on) { filt.classList.toggle('is-open', on); scrim.hidden = !on; document.documentElement.classList.toggle('tcc-lock', on); if (on) { var f = filt.querySelector('input,button'); if (f) f.focus(); } }
    root.querySelector('[data-tcc-filtopen]').addEventListener('click', function () { drawer(true); });
    root.querySelectorAll('[data-tcc-filtclose]').forEach(function (b) { b.addEventListener('click', function () { drawer(false); }); });
    scrim.addEventListener('click', function () { drawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && filt.classList.contains('is-open')) drawer(false); });

    /* ---------- compare (up to 3) ---------- */
    var cmp = root.querySelector('[data-tcc-cmp]'), table = root.querySelector('[data-tcc-cmptable]');
    function cardById(id) { return cards.filter(function (c) { return c.getAttribute('data-id') === id; })[0]; }
    function renderCmp() {
      cards.forEach(function (c) { var cb = c.querySelector('[data-tcc-cmpcb]'); cb.checked = state.cmp.indexOf(c.getAttribute('data-id')) > -1; cb.disabled = !cb.checked && state.cmp.length >= 3; });
      if (state.cmp.length < 2 || state.cmpHidden) { cmp.hidden = true; return; }
      cmp.hidden = false;
      root.querySelector('[data-tcc-cmpt]').textContent = 'Comparing ' + state.cmp.length + ' of 3';
      var cs = state.cmp.map(cardById).filter(Boolean);
      function row(label, fn) { return '<tr><th scope="row">' + label + '</th>' + cs.map(function (c) { return '<td>' + fn(c) + '</td>'; }).join('') + '</tr>'; }
      table.innerHTML = '<thead><tr><td></td>' + cs.map(function (c) { return '<th scope="col"><a href="' + esc(c.getAttribute('data-url')) + '">' + esc(c.getAttribute('data-t')) + '</a><button type="button" data-unc="' + c.getAttribute('data-id') + '" aria-label="Remove from compare">×</button></th>'; }).join('') + '</tr></thead><tbody>' +
        row('Type', function (c) { return esc(c._type || '–'); }) +
        row('Active ingredient', function (c) { return esc(c.getAttribute('data-act') || '–'); }) +
        row('Pack size', function (c) { return esc(c._pack.join(', ') || '–'); }) +
        row('Stated use', function (c) { return esc(c.getAttribute('data-use') || 'Not stated'); }) +
        row('Price (inc. VAT)', function (c) { return '<b>' + esc(c.querySelector('[data-tcc-price]').textContent) + '</b>'; }) +
        row('', function (c) { var b = c.querySelector('.tcc-card__b'); return b.tagName === 'A' ? '<a class="tcc-btn" href="' + esc(b.getAttribute('href')) + '">Choose options</a>' : '<button type="button" class="tcc-btn" data-cmpadd="' + c.getAttribute('data-id') + '">Add to cart</button>'; }) + '</tbody>';
      table.querySelectorAll('[data-unc]').forEach(function (b) { b.addEventListener('click', function () { var i = state.cmp.indexOf(b.getAttribute('data-unc')); state.cmp.splice(i, 1); renderCmp(); }); });
      table.querySelectorAll('[data-cmpadd]').forEach(function (b) { b.addEventListener('click', function () { var c = cardById(b.getAttribute('data-cmpadd')); c.scrollIntoView({ behavior: 'smooth', block: 'center' }); c.querySelector('[data-tcc-add]').click(); }); });
    }
    cards.forEach(function (c) {
      c.querySelector('[data-tcc-cmpcb]').addEventListener('change', function (e) {
        var id = c.getAttribute('data-id'), i = state.cmp.indexOf(id);
        if (e.target.checked && i < 0) state.cmp.push(id); if (!e.target.checked && i > -1) state.cmp.splice(i, 1);
        state.cmpHidden = false; renderCmp();
      });
    });
    root.querySelector('[data-tcc-cmphide]').addEventListener('click', function () { state.cmpHidden = true; renderCmp(); });
    root.querySelector('[data-tcc-cmpclear]').addEventListener('click', function () { state.cmp = []; renderCmp(); });

    /* ---------- add to cart ---------- */
    function add(c, btn) {
      var msg = c.querySelector('[data-tcc-msg]'), t = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      var item = { id: +c.getAttribute('data-vid'), quantity: 1 };
      if (c.getAttribute('data-pro') === '1') item.properties = { _Professional_use_confirmed: 'Yes' };
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); }); })
        .then(function () {
          ['cart:refresh', 'cart:update', 'cart-update'].forEach(function (e) { document.dispatchEvent(new CustomEvent(e, { bubbles: true })); });
          msg.innerHTML = 'Added. <a href="/cart">View basket</a>'; btn.textContent = 'Added';
          var pro = c.querySelector('[data-tcc-pro]'); if (pro) pro.hidden = true;
          setTimeout(function () { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000);
        })
        .catch(function (e) { msg.textContent = e.message; btn.textContent = t; btn.disabled = false; });
    }
    cards.forEach(function (c) {
      var b = c.querySelector('[data-tcc-add]'); if (!b) return;
      var pro = c.querySelector('[data-tcc-pro]');
      b.addEventListener('click', function () {
        if (pro) { pro.hidden = !pro.hidden; if (!pro.hidden) pro.querySelector('input').focus(); return; }
        add(c, b);
      });
      if (pro) pro.querySelector('[data-tcc-proadd]').addEventListener('click', function () {
        var cb = pro.querySelector('[data-tcc-procb]');
        if (!cb.checked) { c.querySelector('[data-tcc-msg]').textContent = 'Please tick the box to confirm.'; cb.focus(); return; }
        c.querySelector('[data-tcc-msg]').textContent = ''; add(c, pro.querySelector('[data-tcc-proadd]'));
      });
    });

    /* ---------- calculators (user enters the label rate) ---------- */
    var calc = root.querySelector('[data-tcc-calc]');
    if (calc) {
      var mode = calc.getAttribute('data-tcc-calc');
      var val = function (k) { var n = parseFloat((calc.querySelector('[data-c="' + k + '"]') || {}).value); return isFinite(n) && n > 0 ? n : 0; };
      var out = function (k, t) { calc.querySelector('[data-o="' + k + '"]').textContent = t; };
      var vol = function (l) { return l < 1 ? NUM(l * 1000) + ' ml' : NUM(l, 2) + ' L'; };
      var run = function () {
        if (mode === 'spray') {
          var area = val('area'), rate = val('rate'), water = val('water'), tank = val('tank');
          var prod = area * rate / 10000, wat = area * water / 10000;
          out('prod', area && rate ? vol(prod) : '–');
          out('water', area && water ? NUM(wat, 1) + ' L' : '–');
          out('fills', wat && tank ? Math.ceil(wat / tank - 1e-9) + ' (' + NUM(wat / tank, 1) + ' tanks)' : '–');
          out('pertank', rate && water && tank ? vol(tank * rate / water) : '–');
        } else {
          var a = val('area'), r = val('rate'), bag = val('bag'), kg = a * r / 1000;
          out('kg', a && r ? NUM(kg, kg < 10 ? 2 : 1) + ' kg' : '–');
          out('bags', kg && bag ? Math.ceil(kg / bag - 1e-9) + ' × ' + NUM(bag, 1) + ' kg' : '–');
        }
      };
      calc.addEventListener('input', run); run();
    }

    paintPrices(); render(); renderCmp();
  }
  function boot() { document.querySelectorAll('[data-tcc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
